import { BuildingMultiValuedList } from '../../../Building'
import { ListCell } from '../ListCell'

function TableBuildingListCell({
  List = BuildingMultiValuedList,
  ...restProps
}) {
  return <ListCell {...restProps} List={List} />
}

export default TableBuildingListCell
